import React, { Fragment, FC, useContext, useState, useMemo, useEffect } from "react";
import { Dialog, Transition } from '@headlessui/react';
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


//import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Avatar from "./Avatar";
import FooterNav from "components_custom/FooterNav/FooterNav";
import { useNavigate, useNavigationType } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";

import DaumPostcode from 'react-daum-postcode';
import { UIContext } from "contexts/UIContext";
import Input from "shared/Input/Input";
import Bg from "components_common/Bg/Bg";
import { requestAPI } from "utils/api";
import { GlobalDataContext } from "contexts/GlobalData";
import { text } from "stream/consumers";
import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";


// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const ModifyResidence: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {

	const navigate = useNavigate ();
	//const navigationType = useNavigationType();

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);

	//let textSub = "";

	const [ open, setOpen ] = useState(false);

	const [style, setStyle] = useState({
		height: '470px',
		display: 'block'
	});

	const [inputAddressValue, setInputAddressValue] = useState('');
	const [inputDetailAddressValue, setInputDetailAddressValue] = useState('');
	const [inputZipCodeValue, setInputZipCodeValue] = useState('');
	const [textSub, setTextSub] = useState('');

	useEffect(()=>{
		
		if (initData.token_info.permission_group === "guest") {

			navigate('/me')	
		} else {
			if (initData.userInfo.residence === null) {
				setTextSub("설정된 주소가 없어요.");
			} else {
				
				const _residence = initData.userInfo.residence;

				setTextSub(`현재 등록된 거주지는 [${_residence.main} ${_residence.detail}]이에요.`);
			}
			
		}

	}, []);

	// if (initData.userInfo.residence === null) {
	// 	textSub = "설정된 주소가 없어요."
	// } else {
		
	// 	const _residence = initData.userInfo.residence;

	// 	textSub = `현재 등록된 거주지는 [${_residence.main} ${_residence.detail}]이에요.`;
	// }
	
	const handleSearch = () => {
		setOpen(true);
	};

	const handleSubmit = async () => {

		const _initData = {...initData};
		const _id = _initData.userInfo._id;

		const res_info: any = await requestAPI ('PUT', `v1/user/${_id}/residence`, {
			address: inputAddressValue,
			detailAddress: inputDetailAddressValue,
			zipCode: inputZipCodeValue			
		});

		if (res_info.code === 1000) {
			
			_initData.userInfo = res_info.data.userInfo;
			setInitData(_initData);
			navigate('/me');
		}
	};
	
	const handleCancel = () => {
		navigate('/me');
	};

	
	const onCompletePost = (data: any) => {
		//setModalState();
		
		setInputAddressValue(data.address);
		setInputZipCodeValue(data.zonecode);
		setOpen(false);

		console.log(data.address);
		console.log(data.zonecode);
	};

	const handleBack = () => {
		navigate(-1);
	}

	
	return (
		<>
		
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>
				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>
				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						
						<div className="mt-5" />

						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
							>
							<div
								className={`max-w-2xl`}
							>
								<h2 className={`text-3xl md:text-4xl font-semibold`}>
									거주지 수정
								</h2>
							</div>
						</div>

						<div className="mt-10" />

						<div>
							<span
								className="text-xl font-semibold text-slate-600"
							>
								변경할 거주지를 작성해주세요.
							</span>
						</div>
						<div>
							<span 
								className="text-sm text-slate-600"
							>
								{textSub}
							</span>
						</div>

						<div className="mt-10 md:ml-10 md:mr-10">
							<div className="flex justify-center items-end w-full">
								<div className="w-full">
									
									<h2
										className={`text-lg nc-card-title text-neutral-900 dark:text-neutral-100 font-semibold`}
									>
										주소 {inputZipCodeValue}
									</h2>
									<span
										className={`text-sm block text-neutral-500 dark:text-neutral-400`}
									>
										<Input
											className="w-ful"
											value={inputAddressValue}
											disabled
										/>
									</span>
								</div>
								<div className="w-[100px]">
									<ButtonSecondary
										className="ml-2 !w-[100px]"
										onClick={() => handleSearch()}
									>
										검색
									</ButtonSecondary>		
								</div>
							</div>
							<div className="flex items-end mt-5">
								<div className="w-full">
									<div>
										<h2
											className={`text-lg nc-card-title text-neutral-900 dark:text-neutral-100 font-semibold`}
										>
											상세 주소
										</h2>
										<span
											className={`w-full text-sm block mt-[2px] text-neutral-500 dark:text-neutral-400`}
										>
											<Input
												className="w-full"
												value={inputDetailAddressValue}
												onChange={e => setInputDetailAddressValue(e.target.value)}
											/>
										</span>
									</div>
									
								</div>
							</div>
						</div>
						

						<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
							<ButtonSecondary
								onClick={() => handleCancel()}
							>
								취소
							</ButtonSecondary>
							<ButtonPrimary
								onClick={() => handleSubmit()}
							>
								수정
							</ButtonPrimary>
						</div>
					</div>

				</div>

				{/* <BottomMenu /> */}

				<Transition.Root show={open} as={Fragment}>
					<Dialog as="div" className="relative z-50" onClose={setOpen}>
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0"
							enterTo="opacity-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
						</Transition.Child>

						<div className="fixed inset-0 z-1000 overflow-y-auto">
							<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
							<Transition.Child
								as={Fragment}
								enter="ease-out duration-300"
								enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
								enterTo="opacity-100 translate-y-0 sm:scale-100"
								leave="ease-in duration-200"
								leaveFrom="opacity-100 translate-y-0 sm:scale-100"
								leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							>
								<Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
								<div>
									
									<div className="mt-3 text-left sm:mt-5">
										<Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
											주소검색
										</Dialog.Title>
										<div className="mt-2">
											<div className="text-sm text-gray-500">
												<DaumPostcode
													style={style}
													onComplete={onCompletePost}
												></DaumPostcode> 
											</div>
										</div>
									</div>

								</div>

								<div className="flex justify-between mt-5 sm:mt-6 gap-x-2">
								
								</div>
								</Dialog.Panel>
							</Transition.Child>
							</div>
						</div>
					</Dialog>
				</Transition.Root>

				
				
			</div>
		</>
	);
};

export default ModifyResidence;
